import "./confirmCharityCardDataPassport.scss";

// @vendor
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

// @components
const { OKBoxTitle } = require("commonsComponents/OKBoxTitle");
import { SignaturePattern } from "components/signaturePattern/signaturePattern";
const { buildNotDeductMessageNGOPassport } = require('utilities/NGOHelper');

// @constants
import {
    messages,
    MULTIPLE_OPERATIONS,
    CHARITY_CARD_HIRE,
    CHARITY_CARD_MODIFY
} from "constants/operationTypes";

const { CHARITY_CARD_DATA_DETAILS } = messages;

// @utils
import { i18n } from "core/i18n";
const { formatText, FormattedText } = i18n;

class ConfirmCharityCardDataPassport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOTP: false
        }
    }

    buildNGOContent = () => {
        const { ngos } = this.props;
        const NGOList = ngos.map((ngo, index) => {
            return <li key={index}>{ngo.name}</li>;
        });

        return (
            <div>
                <FormattedText
                    value="modifySolidarityCard-selectedNGOsSummary"
                    className="passport-hire-confirmation__summary-title"
                />
                <ul className="passport-hire-confirmation__selected-ngos-list">
                    {NGOList}
                </ul>
            </div>
        );
    };

    buildNGOsMinLimit = () => {
        const { minAmount } = this.props;
        return (
            <div>
                <FormattedText
                    value="common-minimumLimit"
                    className="passport-hire-confirmation__summary-title"
                />
                <div>
                    <span className="passport-hire-confirmation__summary-data">
                        {`${minAmount} €/`}
                        <FormattedText
                            value="common-month"
                            format="lowercase"
                        />
                    </span>
                </div>
            </div>
        );
    };

    buildNGOsMaxLimit = () => {
        const { maxAmount } = this.props;
        const month = formatText("common-month").toLowerCase();
        const limitlessAmount = formatText("confirmationSolidarityCard-limitlessAmount");
        const textMaxAmount =
            maxAmount === 99999999 ? limitlessAmount : `${maxAmount} €/${month}`;
        return (
            <div>
                <FormattedText
                    value="common-maximumLimit"
                    className="passport-hire-confirmation__summary-title"
                />
                <div>
                    <span className="passport-hire-confirmation__summary-data">
                        {`${textMaxAmount}`}
                    </span>
                </div>
            </div>
        );
    };


    handleChangeDeduct = () => {
        const { showOTP } = this.state;

        this.setState({
            showOTP: !showOTP,
        })
    }


    render() {
        const { showOTP } = this.state;
        const { ngos } =this.props;
        const messageNGO = buildNotDeductMessageNGOPassport(ngos, showOTP, this.handleChangeDeduct);
        let showCheckDeduct = !messageNGO ? true : showOTP;
        const { cardType, immCard } = this.props;
        const panNumber = immCard.get("number");
        const NGOContent = this.buildNGOContent();
        const NGOsMinLimit = this.buildNGOsMinLimit();
        const NGOsMaxLimit = this.buildNGOsMaxLimit();

        const operationParams = {
            id: CHARITY_CARD_DATA_DETAILS,
            requestMulti: [
                {
                    serviceCode: CHARITY_CARD_HIRE,
                    pan: panNumber
                },
                {
                    serviceCode: CHARITY_CARD_MODIFY,
                    pan: panNumber
                }
            ]
        };

        return (
            <Fragment>
                <OKBoxTitle
                    value={
                        <FormattedText value="modifySolidarityCard-confirmationTitle" />
                    }
                    isNotSeparator={true}
                />
                <div className="passport-hire-confirmation__container">
                    <div className="passport-hire-confirmation__validation-message">
                        <FormattedText
                            value="modifySolidarityCard-solidarityCardValidationMessage"
                            injectedStrings={[cardType]}
                        />
                    </div>
                    <div className="row">
                        <div className="col-xs-4">{NGOContent}</div>
                        <div className="col-xs-4">{NGOsMinLimit}</div>
                        <div className="col-xs-4">{NGOsMaxLimit}</div>
                    </div>
                    {messageNGO}
                    {showCheckDeduct && 
                    <div className="passport-hire-confirmation__signature">
                        <SignaturePattern
                            operationType={MULTIPLE_OPERATIONS}
                            operationParams={operationParams}
                            multiOTPMessageCode={CHARITY_CARD_DATA_DETAILS}
                        />
                    </div>
                    }
                </div>
            </Fragment>
        );
    }
}

ConfirmCharityCardDataPassport.propTypes = {
    ngos: PropTypes.array,
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
    cardType: PropTypes.string,
    immCard: PropTypes.object
};

export default { ConfirmCharityCardDataPassport };
